
import { Vue, Component, Ref, Prop } from "vue-property-decorator"
import SectionedFieldSelector from "../Fields/SectionedFieldSelector.vue"
import { TemplateDetails } from "@/types"
import { InheritedTemplateChangingParams } from "@/types/templateDetails"
import { BModal } from "bootstrap-vue"

@Component({
	components: {
		"sectioned-field-selector": SectionedFieldSelector
	}
})
export default class TemplateInheritanceChangingModal extends Vue {
	@Ref() modal!: BModal
	@Ref() sectionedFieldSelector!: SectionedFieldSelector

	@Prop() templateDetails!: TemplateDetails

	@Prop() templateChangingParams!: InheritedTemplateChangingParams

	public show (): void {
		this.modal.show()
	}

	public hide (): void {
		this.modal.hide()
	}

	public get selectedFields (): string[] {
		return this.sectionedFieldSelector.selectedFields
	}

	private get modalTitle (): string {
		return this.templateChangingParams?.losingFields
			? "Changing Inherited Template - Keep Fields?"
			: "Changing Inherited Template"
	}
}
